import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FireflyBubbleComponent } from './bubble.component';
import { FireflyBubbleSeriesComponent } from './bubble-series.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FireflyBubbleComponent, FireflyBubbleSeriesComponent],
  exports: [FireflyBubbleComponent, FireflyBubbleSeriesComponent]
})
export class FireflyBubbleSeriesModule {}
